interface IFormatCurreny {
  value: number;
  locale?: string | string[];
  style?: string;
}
export const formatCurrency = ({
  locale = "pt-BR",
  value,
  style = "currency",
}: IFormatCurreny) => {
  if (typeof value !== "number") {
    parseFloat(value);
  }

  if (style) {
    return new Intl.NumberFormat(locale, {
      style,
      currency: "BRL",
    }).format(value ? value : 0);
  }
  return new Intl.NumberFormat(locale).format(value ? value : 0);
};

export const formatCurrencyNoBrSign = ({
  locale = "pt-BR",
  value,
}: {
  locale?: string;
  value: number | string;
}) => {
  if (typeof value !== "number") {
    value = parseFloat(value);
  }

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(value ? value : 0);
};
